import { createSlice } from '@reduxjs/toolkit'

import {
  createGame,
  getAllGames,
  followGame,
  requestToBeOwner,
  getAllRequestedGame,
  approveOrRejectRequest,
  cancelOwnerShip,
  verifyGame,
  getGameDetails,
  updateGame,
  deleteGameByAdmin,
  submitGame,
} from './actions'
import { State } from './types'

const initialState: State = {
  isLoading: false,
  isCreateGame: false,
  game: {
    owner: '',
    followers: [],
    id: '',
    _id: '',
    avatar: {
      public_id: '',
      url: '',
    },
    cover_photo: {
      public_id: '',
      url: '',
    },
    user_id: '',
    name: '',
    description: '',
    game_url: '',
    game_platform: '',
    game_status: '',
    active_users: [],
    url: '',
    createdAt: '',
    owner_id: '',
  },
  games: [],
  error: null,
  newGame: null,
  message: null,
  requestedGames: [],
}

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    messageCleanUp(state) {
      state.message = ''
    },
    gameCleanUp(state) {
      state.game = {
        owner: '',
        followers: [],
        id: '',
        _id: '',
        avatar: {
          public_id: '',
          url: '',
        },
        cover_photo: {
          public_id: '',
          url: '',
        },
        user_id: '',
        name: '',
        description: '',
        game_url: '',
        game_platform: '',
        game_status: '',
        active_users: [],
        url: '',
        createdAt: '',
        owner_id: '',
      }
    },
    removeOwnerAndOwner_idFromGame(state, action) {
      console.log('action.payload', action.payload)

      const gameId = action.payload
      // console.log('====================================')
      // console.log(gameId)
      // console.log('====================================')

      // Update state by creating a new array with updated game objects
      state.games = state.games.map((game) => {
        // Check if the current game's id matches the gameId
        if (game._id === gameId) {
          // Return a new object with updated owner and owner_id properties
          return {
            ...game,
            owner: null,
            owner_id: null,
          }
        }
        // If the game id doesn't match, return the original game object
        return game
      })
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllGames.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(getAllGames.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.games = payload
      })
      .addCase(getAllGames.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload.errors
        } else {
          state.error = action.error.message
        }
      })
      .addCase(createGame.pending, (state) => {
        state.isCreateGame = true
        state.error = null
      })
      .addCase(createGame.fulfilled, (state, { payload }) => {
        state.isCreateGame = false
        state.newGame = payload
        state.games = [{ ...payload }, ...state.games]
      })
      .addCase(createGame.rejected, (state, action) => {
        state.isCreateGame = false
        if (action.payload) {
          state.error = action.payload.errors || action.payload.message
        } else {
          state.error = action.error.message
        }
      })
      .addCase(followGame.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(followGame.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.game = payload

        // console.log('payload', payload)

        // state.games = state.games.map((game) => {
        //   if (game.id === payload.id) {
        //     return payload
        //   }
        //   return game
        // })

        // const index = state.games.findIndex((game) => game.id === payload.id)

        // // If the game exists in the state.games array, update it
        // if (index !== -1) {
        //   state.games[index] = payload
        // }
      })
      .addCase(followGame.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload.errors
        } else {
          state.error = action.error.message
        }
      })
      .addCase(requestToBeOwner.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(requestToBeOwner.fulfilled, (state, { payload }) => {
        state.isLoading = false
        // console.log('payload', payload)
        state.message = 'Request sent successfully!'
        // state.game = payload
      })
      .addCase(requestToBeOwner.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload.errors
          state.message = action.payload.message
        } else {
          state.error = action.error.message
        }
      })
      .addCase(getAllRequestedGame.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(getAllRequestedGame.fulfilled, (state, { payload }) => {
        state.isLoading = false
        // console.log('payload', payload)

        state.requestedGames = payload
      })
      .addCase(getAllRequestedGame.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload.errors
        } else {
          state.error = action.error.message
        }
      })
      .addCase(approveOrRejectRequest.pending, (state) => {
        state.isLoading = true
        state.error = null
      })

      .addCase(approveOrRejectRequest.fulfilled, (state, { payload }) => {
        state.isLoading = false

        // Extract the updated request status and _id from the payload
        // const { _id, status }: any = payload.request
        // console.log(_id, status, 'id and status')

        // const requestToUpdate = state.requestedGames.find(
        //   (request: any) => request.id === _id,
        // )

        // if (requestToUpdate) {
        //   requestToUpdate.status = status
        // }
        //  remove the request from the requestedGames array
        state.requestedGames = payload.requests

        state.game = payload.game
        state.message = payload.message
      })

      .addCase(approveOrRejectRequest.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload.errors
          state.message = action.payload.message
        } else {
          state.error = action.error.message
        }
      })
      .addCase(cancelOwnerShip.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(cancelOwnerShip.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.game = payload.game
        state.message = payload.message
      })
      .addCase(cancelOwnerShip.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload.errors
          state.message = action.payload.message
        } else {
          state.error = action.error.message
        }
      })
      .addCase(verifyGame.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(verifyGame.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.game = payload.game
        state.message = payload.message
        // Update the game in the games list too
        const idx = state.games.findIndex((g) => g._id === payload.game._id)
        if (idx !== -1) {
          state.games[idx] = payload.game
        }
      })
      .addCase(verifyGame.rejected, (state, action) => {
        state.isLoading = false
        if (action.payload) {
          state.error = action.payload.errors
          state.message = action.payload.message
        } else {
          state.error = action.error.message
        }
      })
      .addCase(getGameDetails.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(getGameDetails.fulfilled, (state, { payload }) => {
        state.isLoading = false
        // console.log('payload', payload)
        state.game = payload
      })
      .addCase(getGameDetails.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload.errors
        } else {
          state.error = action.error.message
        }
      })
      .addCase(updateGame.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(updateGame.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.game = payload.game
        state.message = payload.message
      })
      .addCase(updateGame.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload.errors
          state.message = action.payload.message
        } else {
          state.error = action.error.message
        }
      })
      .addCase(deleteGameByAdmin.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(deleteGameByAdmin.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.message = payload.message
        // exclude the deleted game from the games array
        state.games = state.games.filter(
          (game) => game._id !== payload.game._id,
        )
      })
      .addCase(deleteGameByAdmin.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload.errors
          state.message = action.payload.message
        } else {
          state.error = action.error.message
        }
      })
      .addCase(submitGame.pending, (state) => {
        state.isCreateGame = true
        state.error = null
      })
      .addCase(submitGame.fulfilled, (state, { payload }) => {
        state.isCreateGame = false
        state.games = [{ ...payload.game }, ...state.games]
        state.message = payload.msg
      })
      .addCase(submitGame.rejected, (state, action) => {
        state.isCreateGame = false
        if (action.payload) {
          state.error = action.payload.errors || action.payload.message
          state.message = action.payload.message
        } else {
          state.error = action.error.message
        }
      })
  },
})

export const { reducer, actions } = gameSlice
export const { messageCleanUp, removeOwnerAndOwner_idFromGame, gameCleanUp } =
  gameSlice.actions

export default gameSlice
